import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private hidden = 'hide';
  private showInfo = 'info';
  private showError = 'error';

  private alert = new BehaviorSubject('hide');
  showAlertStatus = this.alert.asObservable();

  private header = new BehaviorSubject('');
  headerMessage = this.header.asObservable();

  private alertMessage = new BehaviorSubject('');
  showAlertMessage = this.alertMessage.asObservable();

  constructor() { }

  info(message: string,_header?: string): void {
    this.alert.next(this.showInfo);
    this.alertMessage.next(message);
    this.header.next(_header);
  }

  error(message: string): void {
    this.alert.next(this.showError);
    this.alertMessage.next(message);
  }

  hide(): void {
    this.alert.next(this.hidden);
  }
}
